import React, { useEffect, useState } from 'react';
// Material-UI imports removidos em favor do Tailwind Glassmorphism
import jsPDF from 'jspdf';
import axios from "axios";
import GlobalLoading from '../components/GlobalLoading';

import logo from "../assets/logo.png";
// Imports de imagens estáticas removidos em favor das imagens dinâmicas do banco


const GerarOrcamento = () => {
    const [clientes, setClientes] = useState([]);
    const [produtos, setProdutos] = useState([]);
    const [clienteSelecionado, setClienteSelecionado] = useState('');
    const [quantidades, setQuantidades] = useState({}); // Quantidades de produtos selecionados
    const [produtosSelecionados, setProdutosSelecionados] = useState({}); // Controle de seleção dos produtos
    const [filtroCategoria, setFiltroCategoria] = useState('');
    const [categorias, setCategorias] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [productsPerPage] = useState(14);
    const [erroOpenCliente, setErroOpenCliente] = useState(false);
    const [erroOpenProduto, setErroOpenProduto] = useState(false);
    const [erroOpenQuantidade, setErroOpenQuantidade] = useState(false);
    const [imagensSelecionadas, setImagensSelecionadas] = useState([]);
    const [imagensDisponiveis, setImagensDisponiveis] = useState([]); // Nova listagem do BD
    const [currentImagePage, setCurrentImagePage] = useState(1);
    const [imagesPerPage] = useState(4);
    const [erroImagemSelecionada, setErroImagemSelecionada] = useState(false);
    const [prazoEntrega, setPrazoEntrega] = useState('45');

    // Novos estados
    const [desconto, setDesconto] = useState(0);
    const [loading, setLoading] = useState(true);

    // Calcular totais dinamicamente
    const subtotal = produtos.reduce((acc, produto) => {
        const qtd = quantidades[produto.id] ? parseInt(quantidades[produto.id], 10) : 0;
        return acc + (qtd > 0 ? produto.valor_venda * qtd : 0);
    }, 0);
    const totalGeral = Math.max(0, subtotal - parseFloat(desconto || 0));

    useEffect(() => {
        const loadAll = async () => {
            setLoading(true);
            await Promise.all([
                fetchClients(),
                fetchProducts(),
                fetchImagesMetadata()
            ]);
            setLoading(false);
        };
        loadAll();
    }, []);

    const fetchImagesMetadata = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/imageRoutes/metadata`);
            if (Array.isArray(response.data)) {
                setImagensDisponiveis(response.data);
            }
        } catch (error) {
            console.error('Erro ao buscar metadados de imagens:', error);
        }
    };

    const fetchClients = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/clientRoutes/clientes`);
            if (Array.isArray(response.data)) {
                setClientes(response.data);
            } else {
                console.error('Erro: dados de clientes não são um array.');
            }
        } catch (error) {
            console.error('Error fetching clients:', error);
        }
    };

    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/productRoutes/product`);
            if (Array.isArray(response.data)) {
                setProdutos(response.data);

                // Ordena as categorias (exemplo: ordem alfabética)
                const categoriasUnicas = [...new Set(response.data.map(p => p.categoria))];
                const categoriasOrdenadas = categoriasUnicas.sort();
                setCategorias(categoriasOrdenadas);
            } else {
                console.error('Erro: dados de produtos não são um array.');
            }
        } catch (error) {
            console.error('Erro ao buscar produtos:', error);
        }
    };

    const handleClienteChange = (event) => {
        setClienteSelecionado(event.target.value);
    };

    const handleQuantidadeChange = (produtoId, event) => {
        const quantidade = event.target.value;
        if (quantidade === "" || quantidade >= 0) { // Impede valores negativos, mas permite apagar (string vazia)
            setQuantidades((prevState) => ({
                ...prevState,
                [produtoId]: quantidade,
            }));
        }
    };

    const handleQuantidadeIncrement = (produtoId) => {
        setQuantidades(prev => {
            const current = prev[produtoId] ? parseInt(prev[produtoId], 10) : 0;
            return { ...prev, [produtoId]: current + 1 };
        });
    };

    const handleQuantidadeDecrement = (produtoId) => {
        setQuantidades(prev => {
            const current = prev[produtoId] ? parseInt(prev[produtoId], 10) : 0;
            if (current <= 0) return prev;
            return { ...prev, [produtoId]: current - 1 };
        });
    };

    const handleLimparOrcamento = () => {
        setClienteSelecionado('');
        setQuantidades({});
        setFiltroCategoria('');
        setImagensSelecionadas([]);
        setDesconto(0);
        setPrazoEntrega('45');
        setCurrentPage(1);
        setCurrentImagePage(1);
    };

    // const handleCheckboxChange = (produtoId) => {
    //     setProdutosSelecionados((prevState) => ({
    //         ...prevState,
    //         [produtoId]: !prevState[produtoId], // Inverte o estado de seleção do produto
    //     }));
    // };

    const handleImagemCheckboxChange = (imagemId) => {
        imagemId = Number(imagemId); // Garante que seja number

        setImagensSelecionadas((prevSelecionadas) => {
            // Se já está selecionado, desmarca
            if (prevSelecionadas.includes(imagemId)) {
                return prevSelecionadas.filter(id => id !== imagemId);
            }

            // Sem limite, permite adicionar
            return [...prevSelecionadas, imagemId];
        });
    };

    const handleFiltroCategoriaChange = (event) => {
        setFiltroCategoria(event.target.value);
        setCurrentPage(1);
    };

    const formatarParaBRL = (valor) => {
        return new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
        }).format(valor);
    };

    function validaProdutosSelecionados() {
        var validador = false;

        produtos.forEach(produto => {
            if (quantidades[produto.id] != undefined && quantidades[produto.id] != 0) {
                validador = true
            }
        });

        return validador
    }

    function validaQuantidadeSelecionados() {
        var quantidade = 0;

        produtos.forEach(produto => {
            if (quantidades[produto.id] != undefined && quantidades[produto.id] != 0) {
                quantidade += 1
            }
        });

        return quantidade
    }

    const gerarOrcamentoPDF = async () => {
        if (!clienteSelecionado) {
            setErroOpenCliente(true); // Abre o popup de erro se nenhum cliente foi selecionado
            return;
        }

        if (!validaProdutosSelecionados()) {
            setErroOpenProduto(true); // Abre o popup de erro se nenhum produto foi selecionado
            return;
        }

        if (validaQuantidadeSelecionados() > 12) {
            setErroOpenQuantidade(true); // Abre o popup de erro se muitos produtos foram selecionados
            return;
        }

        // Busca as imagens selecionadas em Base64
        let imagensBase64 = [];
        if (imagensSelecionadas.length > 0) {
            try {
                const resImagens = await axios.post(`${process.env.REACT_APP_API_URL || "https://api.clelton-churrasqueiras.site"}/imageRoutes/fetch-selected`, { ids: imagensSelecionadas });
                if (Array.isArray(resImagens.data)) {
                    imagensBase64 = resImagens.data;
                }
            } catch (err) {
                console.error("Erro ao buscar imagens para o PDF", err);
                alert("Erro ao buscar as imagens selecionadas. O orçamento será gerado sem elas.");
            }
        }

        const doc = new jsPDF();

        // Definir o layout da página (em formato ABNT)
        const margem = 10;  // Margem de 10 pixels
        const larguraPagina = 200;  // Largura total da página (210mm - 2 * 10mm)
        const alturaPagina = 290;  // Altura total da página (297mm - 2 * 10mm)

        doc.setFont('Arial', 'normal'); // Fonte Arial
        doc.setFontSize(10); // Tamanho da fonte para todo o documento

        // Inserir o logo da empresa (diminuído)
        doc.addImage(logo, 'PNG', margem, margem, 30, 30);  // Logo da empresa na posição superior esquerda

        // Informações da empresa (Cabeçalho)
        doc.setFontSize(10);
        doc.setFont("Arial", "bold");
        doc.text('Empresa CS Churrasqueiras', margem + 35, margem + 5);  // Nome da empresa em negrito
        doc.setFont("Arial", "normal");
        doc.text('Razão Social: CS CHURRASQUEIRAS GIRATÓRIAS', margem + 35, margem + 10);  // Razão Social
        doc.text('Inscrição Municipal: ', margem + 35, margem + 15);  // Inscrição Municipal na coluna da direita
        doc.text('CNPJ: 30.402.034/0001-73', margem + 35, margem + 20);  // CNPJ
        doc.text('Endereço: Rua Teresina, nº 175, Bairro Tapajós, Município de Indaial/SC', margem + 35, margem + 25);  // Endereço

        // Coluna direita com informações adicionais
        doc.text('Telefone: (47) 98849-2122', margem + 120, margem + 10);  // Telefone na coluna da direita
        doc.text('Email: cleltoncschurrasqueiras@gmail.com', margem + 120, margem + 15);  // Email na coluna da direita
        doc.text('Site: ', margem + 120, margem + 20);  // Site na coluna da direita

        // Linha horizontal para encapsular o cabeçalho
        doc.setLineWidth(0.5);
        doc.line(margem, 40, larguraPagina, 40);  // Linha de separação entre cabeçalho e conteúdo

        let yPosition = 45;

        // Informações do cliente
        const cliente = clientes.find(cliente => String(cliente.id) === String(clienteSelecionado));
        if (!cliente) {
            console.error("Cliente não encontrado.");
            return;
        }

        doc.setFontSize(10);
        doc.text(`Cliente: ${cliente.nome}`, margem, yPosition); // Nome do cliente
        doc.text(`Endereço: ${cliente.rua}, bairro ${cliente.bairro}, ${cliente.cidade} - ${cliente.estado}`, margem, yPosition + 5); // Endereço do cliente
        doc.text(`Cidade: ${cliente.cidade}`, margem, yPosition + 10); // Cidade do cliente
        doc.text(`Telefone: ${cliente.telefone}`, margem, yPosition + 15); // Telefone do cliente
        doc.text(`Email: ${cliente.email}`, margem, yPosition + 20); // Email do cliente

        // Informações adicionais alinhadas à direita
        doc.text(`CPF/CNPJ: ${cliente.cpf_cnpj}`, margem + 120, yPosition); // CPF/CNPJ do cliente
        doc.text(`CEP: ${cliente.cep}`, margem + 120, yPosition + 5); // CEP do cliente

        // Linha horizontal para separar
        yPosition += 25;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Seção de informações adicionais
        yPosition += 5;
        doc.text(`Operação: Orçamento`, margem, yPosition); // Tipo de operação
        doc.text(`Prazo de entrega: ${prazoEntrega} dias`, margem, yPosition + 5);
        doc.text(`Validade: 10 dias`, margem, yPosition + 10); // Validade do orçamento

        // Data de emissão (data atual)
        const dataEmissao = new Date();
        const dataFormatada = `${dataEmissao.getDate()}/${dataEmissao.getMonth() + 1}/${dataEmissao.getFullYear()}`;
        doc.text(`Data de Emissão: ${dataFormatada}`, margem, yPosition + 15); // Data de emissão

        // Linha horizontal para separar
        yPosition += 20;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Título "Produtos/Serviços"
        yPosition += 5;
        doc.setFontSize(12);
        doc.setFont("Arial", "bold");
        doc.text('Produtos/Serviços', larguraPagina / 2, yPosition, null, null, 'center'); // Título centralizado
        doc.setFont("Arial", "normal");

        // Linha horizontal abaixo do título
        yPosition += 4;
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Tabela de itens do orçamento (ajuste da largura das colunas)
        yPosition += 8;
        const colunas = ['Quant.', 'Descrição do produto', 'Valor Un.', 'Valor Final'];
        const larguraColunas = [20, 107, 33, 30];  // Ajuste das larguras das colunas para alinhar corretamente

        doc.setFont("Arial", "bold");

        let xPos = margem;
        colunas.forEach((coluna, index) => {
            doc.text(coluna, xPos, yPosition);
            xPos += larguraColunas[index];
        });

        yPosition += 10; // Aumentar a altura após o cabeçalho

        doc.setFont("Arial", "normal");
        doc.setFontSize(10);

        let subtotalPDF = 0;
        produtos.forEach(produto => {
            const quantidade = quantidades[produto.id];
            if (quantidade > 0) {
                const subtotalItem = produto.valor_venda * quantidade;
                subtotalPDF += subtotalItem;

                // Verifica se a próxima linha ultrapassará os 5 pixels do final
                if (yPosition + 8 > alturaPagina - 20) {  // Mudança aqui, 20px de margem no final
                    doc.addPage();  // Adiciona uma nova página
                    yPosition = 15; // Redefine a posição Y na nova página
                }

                // Desenhar uma linha para cada produto
                xPos = margem;  // Reinicia a posição horizontal
                doc.text(`${quantidade}`, xPos, yPosition);
                xPos += larguraColunas[0];

                doc.text(`${produto.nome}`, xPos, yPosition);
                xPos += larguraColunas[1];

                doc.text(formatarParaBRL(produto.valor_venda), larguraPagina - 63, yPosition, { align: 'left' }); // Alinhado à direita
                xPos += larguraColunas[2];

                doc.text(formatarParaBRL(subtotalItem), larguraPagina - 30, yPosition, { align: 'left' }); // Alinhado à direita
                yPosition += 5;  // Ajustar a posição para a próxima linha
            }
        });

        // Adicionar a linha de totalização (Subtotal, Desconto, Total Geral)
        xPos = margem;
        doc.setFontSize(10);

        const descPDF = parseFloat(desconto) || 0;
        const totalGeralPDF = Math.max(0, subtotalPDF - descPDF);

        doc.text('Subtotal:', larguraPagina - 50, yPosition + 4, { align: 'right' });
        doc.text(formatarParaBRL(subtotalPDF), larguraPagina - 20, yPosition + 4, { align: 'right' });
        yPosition += 6;

        if (descPDF > 0) {
            doc.setTextColor(239, 68, 68); // Red
            doc.text('Desconto:', larguraPagina - 50, yPosition + 4, { align: 'right' });
            doc.text(`- ${formatarParaBRL(descPDF)}`, larguraPagina - 20, yPosition + 4, { align: 'right' });
            yPosition += 6;
            doc.setTextColor(0, 0, 0); // Black
        }

        doc.setFontSize(12);
        doc.setFont("Arial", "bold");
        doc.text('Total Geral:', larguraPagina - 50, yPosition + 4, { align: 'right' });
        doc.text(formatarParaBRL(totalGeralPDF), larguraPagina - 20, yPosition + 4, { align: 'right' });
        yPosition += 8;
        doc.setFont("Arial", "normal");  // Voltando ao estilo normal para o valor total

        // Linha horizontal para separar
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);  // Linha de separação

        // Seção com imagens ilustrativas (Grid Dinâmico)
        if (imagensBase64.length > 0) {
            let imagensPorLinha = 3;
            let imagemLargura = 56;
            let imagemAltura = 42;
            let espacamentoX = 6;

            // Se houver 1 ou 2 imagens, deixa elas maiores
            if (imagensBase64.length <= 2) {
                imagensPorLinha = 2;
                imagemLargura = 85;
                imagemAltura = 64;
                espacamentoX = 10;
            }

            const espacamentoY = 10; // Reduzido de 20 para aproximar as linhas

            let currentY = yPosition + 10;

            imagensBase64.forEach((imgObj, index) => {
                const coluna = index % imagensPorLinha;
                const linhaAtual = Math.floor(index / imagensPorLinha);
                const imagensNestaLinha = Math.min(imagensPorLinha, imagensBase64.length - (linhaAtual * imagensPorLinha));

                const larguraDestaLinha = (imagensNestaLinha * imagemLargura) + ((imagensNestaLinha - 1) * espacamentoX);
                const margemEsquerdaDestaLinha = 10 + (190 - larguraDestaLinha) / 2;

                if (coluna === 0 && index !== 0) {
                    currentY += imagemAltura + espacamentoY;
                }

                // Verifica quebra de página
                // A imagem + texto ocupa cerca de imagemAltura + 10px.
                // Exigimos apenas 5px de margem final até a alturaPagina (já que alturaPagina é conservadora).
                if (currentY + imagemAltura + 15 > alturaPagina) {
                    doc.addPage();
                    currentY = 20;
                }

                const currentX = margemEsquerdaDestaLinha + (coluna * (imagemLargura + espacamentoX));

                try {
                    let imgFormat = 'PNG'; // Fallback
                    if (imgObj.imagem_base64.includes('image/')) {
                        const match = imgObj.imagem_base64.match(/image\/([a-zA-Z]*);/);
                        if (match && match[1]) {
                            imgFormat = match[1].toUpperCase();
                            if (imgFormat === 'JPG') imgFormat = 'JPEG';
                        }
                    }
                    doc.addImage(imgObj.imagem_base64, imgFormat, currentX, currentY, imagemLargura, imagemAltura);
                } catch (e) {
                    console.log("Erro ao adicionar imagem", e);
                }

                doc.setTextColor(169, 169, 169);
                doc.setFontSize(8);
                const imgRef = imagensDisponiveis.find(i => i.id === imgObj.id);
                const nomeImagemReal = imgRef ? imgRef.nome : 'Imagem';
                const textoImagem = `* ${nomeImagemReal} (Ilustrativa)`;
                const textWidth = doc.getTextWidth(textoImagem);
                doc.text(textoImagem, currentX + (imagemLargura / 2) - (textWidth / 2), currentY + imagemAltura + 5);
            });

            yPosition = currentY + imagemAltura + 15;
        } else {
            yPosition += 10;
        }

        // Verifica quebra de página antes das observações
        // O bloco de observações consome cerca de 30px de altura.
        // Exigimos 15px de margem final até a alturaPagina.
        if (yPosition + 45 > alturaPagina) {
            doc.addPage();
            yPosition = 20; // Nova margem na nova página
        }

        // Linha inferior separadora
        doc.setLineWidth(0.5);
        doc.line(margem, yPosition, larguraPagina, yPosition);

        // Seção de "Observações Comerciais"
        yPosition += 10;
        doc.setFontSize(10);
        doc.setTextColor(0, 0, 0); // Cor preta
        doc.text('Observações Comerciais:', margem, yPosition);
        yPosition += 7;

        const observacoes = [
            '- Garantia de 06 (seis) meses para a parte elétrica dos produtos.',
            '- Garantia de 03 (três) anos para defeitos de fabricação conforme contrato.',
            '- Garantia de 10 (dez) anos para as peças de inox contra oxidação natural.'
        ];

        observacoes.forEach((obs, index) => {
            doc.text(obs, margem, yPosition + (index * 5));
        });

        // Rodapé - Ajuste para ficar a 10 pixels do final
        const yRodape = alturaPagina - 1;  // Posição para o rodapé a 10 pixels do final da página
        const dataRodape = new Date().toLocaleDateString('pt-BR');
        doc.setFontSize(8);
        doc.setTextColor(169, 169, 169);  // Cor cinza para o rodapé

        // Alinhamento do rodapé (data à direita e nome da empresa à esquerda)
        doc.text(dataRodape, larguraPagina - 20, yRodape, { align: 'right' });  // Data à direita
        doc.text(`CS Churrasqueiras`, margem, yRodape);  // Nome da empresa à esquerda

        // Extrair o nome do cliente e usar apenas o primeiro e segundo nome
        const nomeCliente = cliente.nome.trim().split(' ').slice(0, 2).join(' ');  // Pega apenas o primeiro e segundo nome
        const nomeArquivo = `Orcamento - ${nomeCliente}.pdf`;  // Cria o nome do arquivo

        // Salvar o PDF com o nome "orcamento-'primeiro e segundo nome do cliente'"
        doc.save(nomeArquivo);
    };

    // Ordena os produtos por categoria e nome antes de exibir
    const produtosOrdenados = produtos
        .filter(produto => !filtroCategoria || produto.categoria === filtroCategoria)
        .sort((a, b) => {
            if (a.categoria === b.categoria) {
                return a.nome.localeCompare(b.nome);
            }
            return a.categoria.localeCompare(b.categoria);
        });

    const totalPages = Math.ceil(produtosOrdenados.length / productsPerPage);
    const currentProducts = produtosOrdenados.slice((currentPage - 1) * productsPerPage, currentPage * productsPerPage);

    const handlePageChange = (direction) => {
        if (direction === 'next' && currentPage < totalPages) {
            setCurrentPage(prevPage => prevPage + 1);
        } else if (direction === 'prev' && currentPage > 1) {
            setCurrentPage(prevPage => prevPage - 1);
        }
    };

    // Paginação das imagens
    const totalImagePages = Math.ceil(imagensDisponiveis.length / imagesPerPage);
    const currentImages = imagensDisponiveis.slice((currentImagePage - 1) * imagesPerPage, currentImagePage * imagesPerPage);

    const handleImagePageChange = (direction) => {
        if (direction === 'next' && currentImagePage < totalImagePages) {
            setCurrentImagePage(prevPage => prevPage + 1);
        } else if (direction === 'prev' && currentImagePage > 1) {
            setCurrentImagePage(prevPage => prevPage - 1);
        }
    };

    // Função para fechar o popup de erro
    const handleCloseError = () => {
        setErroOpenCliente(false);
        setErroOpenProduto(false);
        setErroOpenQuantidade(false);
        setErroImagemSelecionada(false);
    };

    return (
        <div className="p-4 md:p-8 animate-fade-in max-w-7xl mx-auto">
            <div className="flex flex-col mb-8">
                <h1 className="text-3xl text-white font-bold tracking-wide">Geração de Orçamento</h1>
                <p className="text-gray-400 mt-2 text-sm">Selecione o cliente, defina o prazo e as quantidades de produtos.</p>
            </div>
                    {/* Top Section */}
                    <div className="flex flex-col lg:flex-row gap-6 mb-6">
                {/* Left Side: Cliente, Prazo e Filtros */}
                <div className="w-full lg:w-2/3 flex flex-col gap-6">
                    <div className="glass-panel p-5">
                        <div className="flex items-center gap-2 mb-4 cursor-pointer">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                            <h2 className="text-sm font-semibold text-gray-200">Dados do Cliente & Prazo</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-400 mb-1">Cliente</label>
                                <select
                                    value={clienteSelecionado}
                                    onChange={handleClienteChange}
                                    className="glass-input w-full appearance-none bg-background-darker text-sm"
                                >
                                    <option value="" disabled>Selecione um cliente</option>
                                    {clientes.map(cliente => (
                                        <option key={cliente.id} value={cliente.id}>{cliente.nome}</option>
                                    ))}
                                </select>
                            </div>
                            <div>
                                <label className="block text-xs font-medium text-gray-400 mb-1">Prazo de Entrega (dias)</label>
                                <input
                                    type="number"
                                    value={prazoEntrega}
                                    onChange={(e) => setPrazoEntrega(e.target.value)}
                                    className="glass-input w-full text-sm"
                                    min="1"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="glass-panel p-5">
                        <div className="flex items-center gap-2 mb-4 cursor-pointer">
                            <svg className="w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path></svg>
                            <h2 className="text-sm font-semibold text-gray-200">Filtros Avançados</h2>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div>
                                <label className="block text-xs font-medium text-gray-400 mb-1">Categoria</label>
                                <select
                                    value={filtroCategoria}
                                    onChange={handleFiltroCategoriaChange}
                                    className="glass-input w-full appearance-none bg-background-darker text-sm"
                                >
                                    <option value="">Todas as Categorias</option>
                                    {categorias.map((categoria, index) => (
                                        <option key={index} value={categoria}>{categoria}</option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side: Arquivos (Imagens Ilustrativas) */}
                <div className="w-full lg:w-1/3">
                    <div className="glass-panel p-5 h-full flex flex-col">
                        <div className="flex justify-between items-center mb-4">
                            <h2 className="text-sm font-semibold text-gray-200">Selecione as imagens</h2>
                            {imagensSelecionadas.length > 0 && (
                                <button
                                    onClick={() => setImagensSelecionadas([])}
                                    className="text-xs text-red-400 hover:text-red-300 transition-colors"
                                >
                                    Limpar
                                </button>
                            )}
                        </div>

                        <div className="flex flex-col gap-1.5 flex-grow overflow-y-auto max-h-[220px] pr-2 custom-scrollbar">
                            {imagensDisponiveis.length === 0 ? (
                                <p className="text-gray-500 text-xs text-center py-4">Nenhuma imagem cadastrada.</p>
                            ) : (
                                currentImages.map(img => (
                                    <label key={img.id} className="relative flex items-center py-2 px-3 cursor-pointer group bg-white/5 rounded-lg hover:bg-white/10 transition-all border border-white/5 hover:border-white/20">
                                        <input
                                            type="checkbox"
                                            checked={imagensSelecionadas.includes(img.id)}
                                            onChange={() => handleImagemCheckboxChange(img.id)}
                                            className="peer sr-only"
                                        />
                                        <div className="w-4 h-4 flex-shrink-0 flex items-center justify-center rounded border border-gray-500 peer-checked:border-primary peer-checked:bg-primary transition-all shadow-none peer-checked:shadow-[0_0_8px_rgba(59,130,246,0.6)]">
                                            <svg className="w-2.5 h-2.5 text-white opacity-0 peer-checked:opacity-100 transition-opacity" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={4}>
                                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                                            </svg>
                                        </div>
                                        <span className="ml-2.5 text-gray-300 text-sm font-medium group-hover:text-white peer-checked:text-white transition-colors flex-1 min-w-0 truncate" title={img.nome}>
                                            {img.nome}
                                        </span>
                                    </label>
                                ))
                            )}
                        </div>
                        {totalImagePages > 1 && (
                            <div className="flex justify-between items-center mt-3 pt-3 border-t border-white/10">
                                <button onClick={() => handleImagePageChange('prev')} disabled={currentImagePage === 1} className="text-xs text-gray-400 hover:text-white disabled:opacity-50">Anterior</button>
                                <span className="text-xs text-gray-500">{currentImagePage}/{totalImagePages}</span>
                                <button onClick={() => handleImagePageChange('next')} disabled={currentImagePage === totalImagePages} className="text-xs text-gray-400 hover:text-white disabled:opacity-50">Próxima</button>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Table Section */}
            <div className="glass-panel overflow-hidden mb-6 border border-white/10">
                <div className="overflow-x-auto">
                    <table className="w-full text-left text-sm text-gray-300">
                        <thead className="bg-[#1b2336] text-xs font-semibold text-gray-400 border-b border-white/10">
                            <tr>
                                <th className="px-4 py-4 w-1/3">Descrição do Produto</th>
                                <th className="px-4 py-4">Categoria</th>
                                <th className="px-4 py-4 text-right">Preço Unitário</th>
                                <th className="px-4 py-4 text-center">Quantidade</th>
                                <th className="px-4 py-4 text-right">Total da Linha</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-white/5 bg-[#151c2c]">
                            {currentProducts.map((produto) => {
                                const qtd = quantidades[produto.id] ? parseInt(quantidades[produto.id], 10) : 0;
                                const subtotalLinha = qtd > 0 ? produto.valor_venda * qtd : 0;
                                return (
                                    <tr key={produto.id} className="hover:bg-white/5 transition-colors group">
                                        <td className="px-4 py-3 font-medium text-gray-200">
                                            {produto.nome}
                                        </td>
                                        <td className="px-4 py-3 text-gray-400 text-xs">
                                            {produto.categoria}
                                        </td>
                                        <td className="px-4 py-3 text-right text-green-400 font-medium text-sm">
                                            {formatarParaBRL(produto.valor_venda)}
                                        </td>
                                        <td className="px-4 py-3">
                                            <div className="flex items-center justify-center gap-3">
                                                <button onClick={() => handleQuantidadeDecrement(produto.id)} className="w-6 h-6 flex items-center justify-center rounded bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white transition-colors">-</button>
                                                <input
                                                    type="number"
                                                    value={quantidades[produto.id] !== undefined ? quantidades[produto.id] : 0}
                                                    onChange={(e) => handleQuantidadeChange(produto.id, e)}
                                                    className="w-12 bg-transparent text-center text-gray-200 font-medium focus:outline-none hide-arrows"
                                                    min="0"
                                                />
                                                <button onClick={() => handleQuantidadeIncrement(produto.id)} className="w-6 h-6 flex items-center justify-center rounded bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white transition-colors">+</button>
                                            </div>
                                        </td>
                                        <td className="px-4 py-3 text-right text-gray-200 font-semibold">
                                            {formatarParaBRL(subtotalLinha)}
                                        </td>
                                    </tr>
                                );
                            })}
                            {currentProducts.length === 0 && (
                                <tr>
                                    <td colSpan="5" className="px-4 py-8 text-center text-gray-500">Nenhum produto encontrado.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* Table Pagination (Estoque Style) */}
            <div className="flex justify-center items-center mt-6 mb-8 space-x-2">
                {Array.from({ length: totalPages }, (_, index) => (
                    <button
                        key={index}
                        onClick={() => setCurrentPage(index + 1)}
                        className={`w-10 h-10 rounded-full flex items-center justify-center font-medium transition-all ${currentPage === index + 1
                            ? 'bg-primary text-white shadow-lg border border-primary/50'
                            : 'bg-white/5 text-gray-400 hover:bg-white/10 border border-white/5 hover:text-white'
                            }`}
                    >
                        {index + 1}
                    </button>
                ))}
            </div>

            {/* Bottom Section: Totals */}
            <div className="flex justify-end mb-8">
                <div className="flex flex-col gap-6 bg-[#151c2c] border border-white/5 rounded-2xl p-6 shadow-2xl w-full md:w-auto md:min-w-[400px]">
                    <div className="text-center md:text-left border-b border-white/10 pb-4">
                        <h3 className="text-xl font-bold text-white leading-tight">Totais do Orçamento</h3>
                    </div>

                    <div className="flex flex-col gap-4">
                        <div className="flex justify-between items-center text-sm">
                            <span className="text-gray-400">Subtotal</span>
                            <span className="text-gray-200 font-medium">{formatarParaBRL(subtotal)}</span>
                        </div>
                        <div className="flex justify-between items-center text-sm gap-4">
                            <span className="text-gray-400">Desconto</span>
                            <div className="relative">
                                <span className="absolute left-3 top-2.5 text-gray-500 text-xs font-medium">R$</span>
                                <input
                                    type="number"
                                    value={desconto}
                                    onChange={(e) => setDesconto(e.target.value)}
                                    className="glass-input w-32 pl-8 pr-3 py-2 text-right text-gray-200 text-sm hide-arrows"
                                    placeholder="0.00"
                                    min="0"
                                />
                            </div>
                        </div>
                        <div className="flex justify-between items-center text-xl mt-2 pt-4 border-t border-white/10">
                            <span className="text-gray-300 font-bold">Total Geral:</span>
                            <span className="text-green-400 font-bold">{formatarParaBRL(totalGeral)}</span>
                        </div>
                    </div>

                    <div className="flex justify-center gap-4 mt-2">
                        <button onClick={handleLimparOrcamento} className="glass-button-danger text-sm px-4">
                            Limpar Orçamento
                        </button>
                        <button onClick={gerarOrcamentoPDF} className="glass-button text-sm px-4">
                            Gerar Orçamento em PDF
                        </button>
                    </div>
                    </div>
                </div>

            {/* Modais de Erro Tailwind */}
            {(erroOpenCliente || erroOpenProduto || erroOpenQuantidade || erroImagemSelecionada) && (
                <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex justify-center items-center z-50 p-4">
                    <div className="glass-panel p-6 max-w-sm w-full animate-fade-in">
                        <h2 className="text-xl font-bold text-red-400 mb-4">Atenção</h2>
                        <div className="text-gray-200 mb-6">
                            {erroOpenCliente && <p>Por favor, selecione um cliente para gerar o orçamento.</p>}
                            {erroOpenProduto && <p>Por favor, selecione ao menos um produto para gerar o orçamento.</p>}
                            {erroOpenQuantidade && <p>Por favor, não selecione mais de 12 produtos para gerar o orçamento.</p>}
                            {erroImagemSelecionada && <p>Por favor, selecione um tipo de imagem para gerar o orçamento.</p>}
                        </div>
                        <div className="flex justify-end">
                            <button onClick={handleCloseError} className="glass-button bg-red-500/20 hover:bg-red-500/40 text-red-400">
                                Fechar
                            </button>
                        </div>
                    </div>
                </div>
            )}
            
            <GlobalLoading isActive={loading} />
        </div>
    );
};

export default GerarOrcamento;
